{
  "slug": "iq-test-instructions-explained",
  "title": "IQ Test Instructions Explained",
  "description": "Understand common IQ-test instructions about timing, skipping, guessing, answer changes, tools, and breaks.",
  "summary": "Instructions define the task and scoring conditions. Reading them carefully is part of producing an interpretable result, not an optional formality.",
  "category": "IQ questions answered",
  "sections": [
    {
      "heading": "Why instructions matter",
      "paragraphs": [
        "A reasoning item can measure something different if calculators, notes, unlimited time, or repeated attempts are introduced. Standard instructions keep the task closer to the conditions represented by the norms.",
        "Do not assume rules from another test. Navigation, guessing, time, and permitted materials can change between sections."
      ]
    },
    {
      "heading": "Common rules to check",
      "paragraphs": [
        "Before starting, determine whether you can skip items, return later, change answers, use scratch paper, pause, take breaks, or receive penalties for wrong answers. Confirm how unanswered items are treated.",
        "Use examples to understand the response format, but do not infer hidden scoring rules that are not stated."
      ]
    },
    {
      "heading": "When something is unclear",
      "paragraphs": [
        "In supervised testing, ask for clarification in the manner allowed before the section starts. The administrator may repeat or explain standard directions without teaching the solution.",
        "For online testing, use the help content before activating a timer. Record a technical problem rather than secretly changing the conditions to compensate."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Should I guess when I do not know an answer?",
      "answer": "Follow the stated scoring rules; guessing can be sensible when wrong answers are not penalized, but policies differ."
    },
    {
      "question": "Can I go back to earlier questions?",
      "answer": "Only when navigation rules allow it. Adaptive tests may intentionally prevent returning."
    }
  ],
  "related": ["how-to-take-an-iq-test", "are-iq-tests-timed", "what-questions-are-on-an-iq-test"],
  "sources": [
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    },
    {
      "label": "International Test Commission — technology-based assessment guidelines",
      "url": "https://www.intestcom.org/page/16"
    }
  ]
}
